<template>
  <transition>
    <svg class="spinner" :class="{ show: show }" v-show="show" width="48px" height="48px" viewBox="-2 -2 48 48">
      <circle class="outline" fill="none" stroke="white" stroke-width="8" stroke-linecap="round" cx="22" cy="22" r="20"></circle>
      <circle class="path" fill="none" stroke-width="4" stroke-linecap="round" cx="22" cy="22" r="20"></circle>
    </svg>
  </transition>
</template>

<script>
  export default {
    name: 'spinner',
    props: ['show'],
    serverCacheKey: props => props.show
  }
</script>

<style>

   .spinner{
     position: fixed;
     z-index: 999;
     right: 15px;
     bottom: 0px;
     transition: opacity .15s ease;
     animation: rotator 1.4s linear infinite;
     animation-play-state: paused;
   }

   .spinner.show{
     animation-play-state: running;
   }
   .spinner.v-enter, .spinner.v-leave-active{
     opacity: 0;
   }

   .spinner.v-enter-active, .spinner.v-leave{
     opacity: 1;
   }

   @keyframes rotator {
     0% {
       transform: scale(0.5) rotate(0deg)
     }
     100% {
       transform: scale(0.5) rotate(0deg)
     }
   }

   .spinner .path {
     stroke: #151d66;
     stroke-dasharray: 126;
     stroke-dashoffset: 0;
     transform-origin: center;
     animation: dash 1.4s ease-in-out infinite;
   }

   @keyframes dash {
     0% {
       stroke-dashoffset: 0;
     }
     100% {
       stroke-dashoffset: 252;
     }
   }

</style>
